import { createAsyncThunk } from "@reduxjs/toolkit"
import { setLoading, setError, setRecommendations } from "./recommendationsSlice"
import { getProducts } from "@/entities/product"

export const fetchRecommendations = createAsyncThunk(
	"recommendations/fetchRecommendations",
	async (params: { id: string; filterBy: string; filterValue: number }, { dispatch }) => {
		const queryParams = new URLSearchParams()
		queryParams.set(params.filterBy, params.filterValue.toString())

		try {
			dispatch(setLoading(true))

			const response = await getProducts({ limit: 9, page: 1, params: queryParams })
			if (response.objects) {
				const removedCurrentProduct = response.objects.filter(product => product.id !== params.id)
				dispatch(setRecommendations(removedCurrentProduct))
			} else {
				dispatch(setError("Товар не найден"))
			}
		} catch (error) {
			console.error("Ошибка при загрузке товара:", error)
			dispatch(setError("Ошибка при загрузке товара"))
		} finally {
			dispatch(setLoading(false))
		}
	}
)
